import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY

const API_BASE_URL = `${urlApi}/api/files`;
const getConfig = (currentPath) => ({
    headers: {
        'x-current-path': encodeURIComponent(currentPath)
    }
});

export const getFiles = async (currentPath = '') => {
    try {
        // CAMBIO CLAVE: Se envía currentPath en el HEADER para GET
        const response = await api.get(API_BASE_URL, getConfig(currentPath));
        return response.data;
    } catch (error) {
        console.error('API Error (getFiles):', error);
        throw error;
    }
};

export const createFile = async (file, currentPath = '', userId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id_user', userId);
    try {

        const response = await api.post(`${API_BASE_URL}/file`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-current-path': encodeURIComponent(currentPath) // Envía currentPath en header para POST de archivo
            }
        });
        return response.data;
    } catch (error) {
        console.error('API Error (createFile):', error);
        throw error;
    }
};

export const downloadFile = (filePath, fileName, userId) => {
    const fileUrl = `${urlApi}/api/files/download?path=${encodeURIComponent(filePath)}&id_user=${encodeURIComponent(userId)}`;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName || ''; // sugerencia
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};